import {ActionType} from '../constants/ActionTypes';
import {RestPath, RoutePath} from '../constants/SitePaths';
import {LocalStorageService} from '../services/LocalStorageService';
import config from '../constants/Configs';
import axios from 'axios';
import constants from "../constants/Constants";
import {message} from "antd";


// Send Code

export const sendCodeBegin = () => ({
    type: ActionType.SEND_CODE_BEGIN
});

export const sendCodeSuccess = user => ({
    type: ActionType.SEND_CODE_SUCCESS,
    payload: {user}
});

export const sendCodeError = (user, error) => ({
    type: ActionType.SEND_CODE_FAILURE,
    payload: {error: error, user: user}
});

// Recover password
export const recoverPasswordBegin = () => ({
    type: ActionType.RECOVER_PASSWORD_BEGIN
});

export const recoverPasswordSuccess = user => ({
    type: ActionType.RECOVER_PASSWORD_SUCCESS,
    payload: {user}
});

export const recoverPasswordError = (error) => ({
    type: ActionType.RECOVER_PASSWORD_FAILURE,
    payload: {error}
});

// Change password
export const changePasswordBegin = () => ({
    type: ActionType.CHANGE_PASSWORD_BEGIN
});

export const changePasswordSuccess = changePasswordData => ({
    type: ActionType.CHANGE_PASSWORD_SUCCESS,
    payload: {changePasswordData}
});

export const changePasswordError = (error) => ({
    type: ActionType.CHANGE_PASSWORD_FAILURE,
    payload: {error},
});

/** Forgot password */
export function sendCode(data, history, intl) {
    LocalStorageService.remove("authorizationData");

    return dispatch => {
        dispatch(sendCodeBegin());
        const params = {
            email: data.email,
            grant_type: "password",
            client_secret: '748434cf2eeca18cd7be9661dce8c39d60f16461c8e760426958493b9f79b52f',
            client_id: 8080,
        };

        return axios({
            method: constants.POST,
            url: config.BASE_URL + RestPath.FORGOT_PASSWORD,
            data: params,

        }).then((response) => {

            LocalStorageService.set("authorizationData", response.data);
            dispatch(sendCodeSuccess(response.data));
            message.success(intl.messages.verification_code_sent);

            history.push({
                state: {email: data.email},
                pathname: RoutePath.FORGOT_PASSWORD_CHANGING,
            });

            return response.data;
        })
            .catch((error) => {
                dispatch(sendCodeError(params, error));
            });
    };
}


/* Recover Password */
export function recoverPassword(data, history, intl) {

    return dispatch => {
        dispatch(recoverPasswordBegin());
        const params = {
            Email: data.email,
            VerificationKey: data.verification_code,
            NewPassword: data.password,
            ConfirmPassword: data.confirm,
        };

        return axios({
            method: constants.PUT,
            url: config.BASE_URL +  RestPath.RECOVER_PASSWORD,
            data: JSON.stringify(params),
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            if (response.status >= 400) {
                // Error
                dispatch(recoverPasswordError(params, response.data));
            } else {
                // Success
                dispatch(recoverPasswordSuccess(params));
                history.push(RoutePath.LOGIN);
                message.success(intl.messages.password_changed);
            }
            return response.data;
        })
            .catch((error) => {
                dispatch(recoverPasswordError(error))
            });
    };
}


/* Change Password */
export function changePassword(data, history, intl) {

    return dispatch => {
        dispatch(changePasswordBegin());

        const params = {
            ...data
        };

        return axios({
            method: constants.PUT,
            url: config.BASE_URL + RestPath.CHANGE_PASSWORD,
            data: JSON.stringify(params),

        }).then((response) => {
            // Success
            dispatch(changePasswordSuccess(params));
            message.success(intl.messages.password_changed);
            return response.data;

        })
            .catch((error) => {
                dispatch(changePasswordError(error));
                return 'error';
            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/AccountActions.js